import { CTASection } from "../shared/cta-section";

export const CTA = () => {
  return (
    <CTASection
      id="planr-cta"
      title="Ready to enable real-time environmental analysis?"
      description="Transform your environmental projects with the same advanced analytics capabilities powering Australia's Nature Repair Market. Contact Haizea Analytics to learn how the Terrak.io platform can deliver the sophisticated analysis your organisation needs."
      buttons={[
        {
          text: "Start Your Environmental Project",
          href: "mailto:contact@haizea.com.au",
          backgroundColorClass: "bg-haizea-green",
        },
      ]}
    />
  );
};
